// チャンネル用の tint パレット。
// 前半は落ち着いたトーン、後半は彩度高めで元気なトーン。背景に載せて白文字が読める。
export const CHANNEL_PALETTE = [
  // 落ち着き系
  '#4A5C8C', // 藍
  '#3A6EA5', // 青
  '#22687A', // 青緑
  '#3B7A66', // モスグリーン
  '#7A6E1C', // オリーブ
  '#A45E22', // 橙
  '#8A3E5E', // ワイン
  '#7E5AA6', // 紫
  '#4A3B8A', // 深紫
  '#556B7A', // グレー青
  // 彩度高め・明るめ
  '#2E7CE6', // 明るい青
  '#00B4D8', // シアン
  '#06B47C', // 明るい緑
  '#7CBB33', // ライム
  '#F5C000', // 山吹
  '#F58A00', // 明るい橙
  '#E63946', // 鮮やか赤
  '#E91E63', // マゼンタ
  '#9C27B0', // バイオレット
  '#5A5CE6', // 青紫
];
